import { render, staticRenderFns } from "./TableFuncionalidades.vue?vue&type=template&id=baf61c86&scoped=true&"
import script from "./TableFuncionalidades.vue?vue&type=script&lang=js&"
export * from "./TableFuncionalidades.vue?vue&type=script&lang=js&"
import style0 from "./TableFuncionalidades.vue?vue&type=style&index=0&id=baf61c86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf61c86",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
